export const PASSCODE_LENGTH = 4;
export function isValidPasscode(passcode) {
  return Boolean(passcode && passcode.length === PASSCODE_LENGTH && /^\d*$/.test(passcode));
}